const HomePath = "/";

export default HomePath;
